import AlGuthmiLogo from "../assets/logo.png";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getStorage, setStorage } from "../helpers/helper";
import {
  Alert,
  Collapse,
  IconButton,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import {
  logClientCompany,
  logClientMobileNumber,
  logClientName,
  logClientNumber,
  logClientOTP,
  logToken,
  signalPagePath,
} from "../signals/login.signal";
import translateText, {
  LanguageDirection,
  currentLanguage,
} from "../signals/language.signal";
import { jwtDecode } from "jwt-decode";
import { cartProductData } from "../signals/orderData.signal";
import LazyImage from "../components/LazyImage";
import { clearToken } from "../helpers/auth";
import CloseIcon from "@mui/icons-material/Close";
import InstallButton from "../components/InstallPWAButton";

// Country codes with validation rules
const countryCodes = [
  {
    code: "+966",
    flag: "🇸🇦",
    country: "Saudi Arabia",
    alt: "SA",
    minLength: 10,
    maxLength: 10,
    placeholder: "501234567",
    pattern: /^[05][0-9]{9}$/,
    format: "05XXXXXXXX",
  },
  {
    code: "+971",
    flag: "🇦🇪",
    country: "UAE",
    alt: "AE",
    minLength: 9,
    maxLength: 9,
    placeholder: "501234567",
    pattern: /^[5][0-9]{8}$/,
    format: "5XXXXXXXX",
  },
  {
    code: "+965",
    flag: "🇰🇼",
    country: "Kuwait",
    alt: "KW",
    minLength: 8,
    maxLength: 8,
    placeholder: "51234567",
    pattern: /^[569][0-9]{7}$/,
    format: "5XXXXXXX",
  },
  {
    code: "+973",
    flag: "🇧🇭",
    country: "Bahrain",
    alt: "BH",
    minLength: 8,
    maxLength: 8,
    placeholder: "36123456",
    pattern: /^[3679][0-9]{7}$/,
    format: "3XXXXXXX",
  },
  {
    code: "+968",
    flag: "🇴🇲",
    country: "Oman",
    alt: "OM",
    minLength: 8,
    maxLength: 8,
    placeholder: "91234567",
    pattern: /^[9][0-9]{7}$/,
    format: "9XXXXXXX",
  },
  {
    code: "+967",
    flag: "🇾🇪",
    country: "Yemen",
    alt: "YE",
    minLength: 9,
    maxLength: 9,
    placeholder: "712345678",
    pattern: /^[7][0-9]{8}$/,
    format: "7XXXXXXXX",
  },
  {
    code: "+974",
    flag: "🇶🇦",
    country: "Qatar",
    alt: "QA",
    minLength: 8,
    maxLength: 8,
    placeholder: "55123456",
    pattern: /^[3567][0-9]{7}$/,
    format: "5XXXXXXX",
  },
  {
    code: "+961",
    flag: "🇱🇧",
    country: "Lebanon",
    alt: "LB",
    minLength: 8,
    maxLength: 8,
    placeholder: "71123456",
    pattern: /^[37][0-9]{7}$/,
    format: "7XXXXXXX",
  },
  {
    code: "+962",
    flag: "🇯🇴",
    country: "Jordan",
    alt: "JO",
    minLength: 9,
    maxLength: 9,
    placeholder: "799123456",
    pattern: /^7[789][0-9]{7}$/,
    format: "7XXXXXXXX",
  },
];

const LoginPage = () => {
  const navigate = useNavigate();
  const [cliCode, setCliCode] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(countryCodes[0]);
  const [pass, setPass] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    getStorage("newProLang")[0] ? setShowModal(false) : setShowModal(true);
    clearToken();
    // Prefill remembered login data if available
    const saved = getStorage("rememberLogin", null);
    if (saved) {
      setRememberMe(true);
      if (saved.cliCode) setCliCode(saved.cliCode);
      if (saved.mobileNo) setMobileNo(saved.mobileNo);
      if (saved.countryCode) {
        const found = countryCodes.find((c) => c.code === saved.countryCode);
        if (found) setSelectedCountry(found);
      }
    }
  }, []);

  const handleClose = () => setShowModal(false);

  const handelLang = (event) => {
    const selectValue = event.target.value;

    currentLanguage.value = selectValue;
    if (selectValue == "ar" || selectValue == "urdu") {
      LanguageDirection.value = "rtl";
    } else {
      LanguageDirection.value = "ltr";
    }
    setStorage("newProLang", [currentLanguage.value, LanguageDirection.value]);
  };
  const showAlertMessage = (MSG) => {
    setAlertMessage(MSG);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };
  const handleCliCodeChange = (event) => {
    setCliCode(event.target.value);
    setValidated(false);
  };

  const handleMobileChange = (event) => {
    const inputValue = event.target.value;
    // Allow only numeric input within the country's max length
    if (!isNaN(inputValue) && inputValue.length <= selectedCountry.maxLength) {
      setMobileNo(inputValue);
    } else if (!inputValue) {
      setMobileNo("");
    }
    setValidated(false);
  };

  const isMobileValid = () => {
    if (mobileNo === "") return false;
    return (
      selectedCountry.pattern.test(mobileNo) &&
      mobileNo.length >= selectedCountry.minLength &&
      mobileNo.length <= selectedCountry.maxLength
    );
  };

  const handlePasseChange = (event) => {
    setPass(event.target.value);
    setValidated(false);
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    setDisabled(true);
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setLoading(false);
      setDisabled(false);
    } else {
      try {
        const response = await authenticateUser(
          cliCode,
          mobileNo,
          pass,
          currentLanguage.value
        );
        if (response && response.token && response.status != 400) {
          setStorage("b2bAppToken", response.token);
          const decodedToken = jwtDecode(response.token);
          cartProductData.value = getStorage("cartData");
          signalPagePath.value = localStorage.getItem("b2bAppToken") !== null;
          logToken.value = response.token;
          logClientNumber.value = decodedToken.data.clientNumber;
          logClientName.value = decodedToken.data.clientName;
          logClientMobileNumber.value = decodedToken.data.clientMobileNumber;
          logClientCompany.value = decodedToken.data.clientCompanyNumber;
          logClientOTP.value = decodedToken.data.cliOTP;
          console.log(decodedToken.data);

          // Remember Me persistence (no password stored)
          if (rememberMe) {
            setStorage("rememberLogin", {
              cliCode,
              mobileNo,
              countryCode: selectedCountry.code,
            });
          } else {
            localStorage.removeItem("rememberLogin");
          }
          if (logClientOTP.value === "0") {
            navigate("/otp");
          } else {
            navigate("/home");
          }
        } else {
          localStorage.removeItem("b2bAppToken");
          showAlertMessage(response.message);
          console.error("Error:", response);
        }
      } catch (error) {
        showAlertMessage("Error:", error);
        console.error("Error:", error);
      } finally {
        setLoading(false);
        setDisabled(false);
      }
    }
    setValidated(true);
  };

  const authenticateUser = async (
    CLIENT_NUMBER,
    MOBILE_NUMBER,
    PASSWORD,
    LANGUAGE
  ) => {
    const username = "Guthmi";
    const password = "ApiCal2023@_2115&";
    const basicAuth = btoa(username + ":" + password);
    const apiUrl = "https://alguthmi.co/API/B2BAppAPI/authenticate.php";
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Basic ${basicAuth}`,
        "Content-Type": "application/json",
        origin: "https://alguthmi.co",
      },
      body: JSON.stringify({
        CLIENT_NUMBER,
        MOBILE_NUMBER,
        PASSWORD,
        LANGUAGE,
      }),
    });

    if (response.ok) {
      const jsonResponse = await response.json();
      return jsonResponse;
    } else {
      showAlertMessage("Authentication failed");
    }
  };

  return (
    <>
      {/* <SideBar more={true} /> */}
      <InstallButton />
      <Collapse
        in={open}
        className="position-fixed m-2"
        style={{ zIndex: 1000, direction: "ltr", top: 0 }}
      >
        <Alert
          severity="error"
          variant="filled"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              className="m-0"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" className="m-0" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {alertMessage}
        </Alert>
      </Collapse>
      <div
        id="loginPage"
        className="align-items-sm-center d-flex justify-content-center w-100  position-absolute"
        style={{ background: primary.value, height: "100dvh" }}
      >
        <div className="loginContaner loginForm rounded-top-5 mt-5 mt-sm-0 bg-white p-3 p-md-5 w-100 shadow-lg d-flex justify-content-center align-items-center">
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            className="w-100 d-md-flex align-items-center"
          >
            <div className="d-flex w-100 flex-column align-items-center mb-3">
              <h1 style={{ color: primary.value, fontWeight: 700 }}>
                {" "}
                {translateText(currentLanguage.value, "loginAccount")}
              </h1>
              <p style={{ fontSize: "12px" }}>
                {" "}
                {translateText(currentLanguage.value, "loginPara")}
              </p>
              <div className="d-flex flex-column align-items-center m-4">
                <LazyImage
                  src={AlGuthmiLogo}
                  alt="logo"
                  style={{
                    width: "130px",
                  }}
                  className="logo"
                />
              </div>
            </div>
            <div className="w-100">
              <div className="mb-3">
                <label
                  htmlFor="clientCode"
                  className="form-label mb-0"
                  style={{ fontSize: "12px" }}
                >
                  {translateText(currentLanguage.value, "ClientCode")}
                </label>
                <input
                  type="number"
                  className={`form-control ${
                    cliCode === ""
                      ? ""
                      : cliCode.length >= 9 && cliCode.length <= 11
                      ? "is-valid"
                      : "is-invalid"
                  }`}
                  id="clientCode"
                  value={cliCode}
                  placeholder="xxxxxx"
                  onChange={handleCliCodeChange}
                  required
                />
                <div className="invalid-feedback">
                  {translateText(currentLanguage.value, "ErrorClientCode")}
                </div>
              </div>
              <div className="mb-3">
                <label
                  className="form-label mb-0"
                  style={{ fontSize: "12px" }}
                  htmlFor="mobileNo"
                >
                  {translateText(currentLanguage.value, "MobileNumber")}
                </label>
                <div className="d-flex gap-2">
                  <FormControl size="small" style={{ minWidth: "130px" }}>
                    <Select
                      value={selectedCountry.code}
                      onChange={(e) => {
                        const country = countryCodes.find(
                          (c) => c.code === e.target.value
                        );
                        setSelectedCountry(country);
                      }}
                      displayEmpty
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        height: "38px",
                      }}
                    >
                      {countryCodes.map((country) => (
                        <MenuItem
                          key={country.code}
                          value={country.code}
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={`https://flagcdn.com/w20/${country.alt.toLowerCase()}.png`}
                            alt={country.alt}
                            style={{
                              width: "20px",
                              height: "15px",
                              borderRadius: "2px",
                              marginRight: "5px",
                              marginBottom: "2px",
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display = "inline";
                            }}
                          />
                          <span
                            style={{
                              display: "none",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            {country.alt}
                          </span>
                          <span>{country.code}</span>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <input
                    type="tel"
                    className={`form-control ${
                      mobileNo === ""
                        ? ""
                        : isMobileValid()
                        ? "is-valid"
                        : "is-invalid"
                    }`}
                    id="mobileNo"
                    placeholder={`${selectedCountry.format}`}
                    value={mobileNo}
                    onChange={handleMobileChange}
                    required
                    style={{ flex: 1 }}
                    maxLength={selectedCountry.maxLength}
                  />
                </div>
                {mobileNo !== "" && !isMobileValid() && (
                  <div
                    className="text-danger mt-1"
                    style={{ fontSize: "14px" }}
                  >
                    {translateText(
                      currentLanguage.value,
                      "ErrorMobileNumber"
                    ) ||
                      `Please enter a valid ${selectedCountry.country} mobile number (${selectedCountry.format})`}
                  </div>
                )}
                <div className="invalid-feedback">
                  {translateText(currentLanguage.value, "ErrorMobileNumber") ||
                    `Please enter a valid ${selectedCountry.country} mobile number (${selectedCountry.format})`}
                </div>
              </div>
              <div className="mb-3">
                <label
                  htmlFor="Password"
                  className="form-label mb-0"
                  style={{ fontSize: "12px" }}
                >
                  {translateText(currentLanguage.value, "Password")}
                </label>

                <input
                  type="password"
                  className={`form-control ${
                    pass === ""
                      ? ""
                      : pass.length >= 10
                      ? "is-valid"
                      : "is-invalid"
                  }`}
                  id="Password"
                  placeholder="******"
                  value={pass}
                  onChange={handlePasseChange}
                  required
                  autoComplete="new-password"
                />
                <div className="invalid-feedback">
                  {translateText(currentLanguage.value, "ErrorPassword")}
                </div>
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="rememberMe">
                  {translateText(currentLanguage.value, "RememberMe")}
                </label>
              </div>

              <button
                type="submit"
                className="btn border btn-primary pe-3 ps-3 w-100 "
                style={{ background: primary.value, color: primaryFount.value }}
                disabled={disabled}
              >
                {loading
                  ? translateText(currentLanguage.value, "Loading") + "..."
                  : translateText(currentLanguage.value, "Login")}
              </button>
            </div>
          </Form>
        </div>
        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          dir={LanguageDirection.value}
        >
          <Modal.Body>
            <p className="form-label d-flex justify-content-between" dir="ltr">
              <span>
                {translateText(currentLanguage.value, "Chose Language")}
              </span>
              <span>{translateText(currentLanguage.value, "اختر لغة")}</span>
            </p>
            <select
              className="form-select mb-3"
              value={currentLanguage.value}
              onChange={handelLang}
            >
              <option value="ar">عربي</option>
              <option value="en">English</option>
              <option value="tr">Türkçe</option>
              <option value="urdu">urdu</option>
              <option value="hi">Hindi</option>
              <option value="my">မြန်မာ</option>
            </select>
            <button
              type="submit"
              className="btn border btn-primary pe-3 ps-3 w-100 "
              style={{ background: primary.value, color: primaryFount.value }}
              onClick={() => setShowModal(false)}
            >
              {loading
                ? translateText(currentLanguage.value, "Save") + "..."
                : translateText(currentLanguage.value, "Save")}
            </button>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default LoginPage;
